<template>
  <quote-request-dialog
    v-model="showDialog"
    :product-id="productId"
    :add-to-quote-event="addToQuoteEvent"
    :create-quote-event="createQuoteEvent"
  >
    <template #activator="{ props: slotProps }">
      <sf-icon-button
        v-bind="slotProps"
        id="quote-button"
        :icon="mdiHandshake"
        :color="isInQuote ? 'green' : 'primary'"
        :aria-label="$t('addProductToQuote')"
        @click="handleClick"
      />
    </template>
  </quote-request-dialog>
</template>

<script setup lang="ts">
import SfIconButton from '@/components/button/SfIconButton.vue'
import QuoteRequestDialog from '@/modules/quote/components/QuoteRequestDialog.vue'
import useAddToQuote from '@/modules/quote/useAddToQuote'
import { Event } from '@/modules/tracking/types'
import { mdiHandshake } from '@mdi/js'
import { storeToRefs } from 'pinia'
import { PropType, ref, watchEffect } from 'vue'

const props = defineProps({
  productId: {
    type: Number,
    required: true
  },
  addToQuoteEvent: {
    type: Object as PropType<Event>,
    required: true
  },
  createQuoteEvent: {
    type: Object as PropType<Event>,
    required: true
  }
})

const showDialog = ref(false)
const { isInQuote } = storeToRefs(useAddToQuote())

watchEffect(() => {
  useAddToQuote().isProductInQuoteRequest(props.productId)
})

const handleClick = () => {
  showDialog.value = true
}
</script>
